export default __webpack_public_path__ + "f55ac4fe6e76271cb6b48295551c22f4.png";